import axios from "axios";
import {DOMAINS} from "./../domains";

export class FavoritesService {

  constructor() {

    this.getList = this.getList.bind(this);
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.getDomainConfig = this.getDomainConfig.bind(this);
    this.getApiUrl = this.getApiUrl.bind(this);

  }

  getDomainConfig() {
    return DOMAINS[window.location.hostname];
  }

  getApiUrl() {

    const domainConfig = this.getDomainConfig().chatConfig;
    let apiUrl = domainConfig.default.favoritesUrl;
    if (domainConfig.hasOwnProperty(window.location.hostname))
      apiUrl = domainConfig[window.location.hostname].favoritesUrl;
    return apiUrl;

  }

  areas = {
    "companies": "exhibitor",
    "products": "product",
    "events": "event",
    "Event": "event",
    "casehistories": "project",
    "exhibitor": "exhibitor",
    "product": "product",
    "event": "event",
    "project": "project",
    "architect": "architect",
    "architects": "architect",
    "project-architects": "project-architects",
    "projects-architects": "project-architects",
    "subcompanies": "architect",
    "subcasehistories": "project-architects",
    "subcompany": "architect",
    "subcasehistory": "project-architects"
  };

  tenants = {
    'MDM': 'MMP',
    'VIR': 'VIR',
    'AGR': 'AGR',
    'FIC': 'FIC',
    'SAM': 'SAM'
  }

  async getList(accessToken, area){

    const domainConfig = this.getDomainConfig();
    const apiUrl = this.getApiUrl();

    return new Promise(async (resolve, reject) => {
      if(area){
        if(apiUrl){
          try {
            const result = await axios.get(apiUrl + "?itemType=" + this.areas[area] + "&exhibitionId=" + this.tenants[domainConfig.tenant], {});
            resolve(result.data);
          } catch (error) {
            console.log(error);
            resolve(null);
          }
        }else{
          resolve(null);
        }
      }else{
        resolve(null);
      }
    });
  }

  async add(accessToken, idUser, area, idElement){

    const domainConfig = this.getDomainConfig();
    const apiUrl = this.getApiUrl();

    return new Promise(async (resolve, reject) => {
      if(apiUrl){
        console.log(this.areas);
        try {
          console.log(area);
          const result = await axios.post(apiUrl, {
            exhibitionId: this.tenants[domainConfig.tenant],
            itemType: this.areas[area],
            itemId: idElement,
            userId: idUser
          })
          resolve(result.data.content);
        } catch (error) {
          console.log(error);
          resolve(null);
        }
      }else{
        resolve(null);
      }
    });
  }

  async remove(accessToken, idUser, area, idElement){

    const domainConfig = this.getDomainConfig();
    const apiUrl = this.getApiUrl();

    return new Promise(async (resolve, reject) => {
      try {
        const result = await axios.delete(apiUrl + "/" + idElement + "?itemType=" + this.areas[area] + "&exhibitionId=" + this.tenants[domainConfig.tenant]);
        resolve(result.data.content);
      } catch (error) {
        console.log(error);
        resolve(null);
      }
    });
  }

}

export default new FavoritesService();
